module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ws-block"
  }, [(_vm.queryBlock) ? _c('fieldset', {
    staticStyle: {
      "border": "1px solid #ddd"
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.queryBlock) ? _c('el-row', [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-134a1d3c!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/block.vue
// module id = 300
// module chunks = 99 100